import { render, staticRenderFns } from "./WorkCarried.vue?vue&type=template&id=c6ad0722&"
import script from "./WorkCarried.vue?vue&type=script&lang=js&"
export * from "./WorkCarried.vue?vue&type=script&lang=js&"
import style0 from "./WorkCarried.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports